@switch (name) {
  @case ('date_period') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('orderBy') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('active') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('role') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('accountId') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="accountFilterSelected($event)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('status') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('customerCanUpload') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('associatedToMachine') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('uploadablePeriodically') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('serialNumbers') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('operatingSector') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('complexity') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('isFavorite') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @case ('language') {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event, name)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }
      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
  @default {
    <div class="select-container">
      <input
        placeholder="{{ translationPrefix + '.' + name | translate | uppercase }}"
        [id]="name"
        type="text"
        class="form-control rounded-0 input-typeahead fw-bold text-truncate"
        [ngClass]="isLight ? 'light' : 'dark'"
        [(ngModel)]="value"
        [ngbTypeahead]="search"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        (selectItem)="itemSelected($event)"
        #instance="ngbTypeahead"
        [name]="name"
        popupClass="typeahead-dropdown"
        [disabled]="disabled || isReloading"
      />
      @if (isReloading) {
        <div class="loading-spinner"></div>
      } @else if (!value) {
        <div class="dropdown-icon">
          <app-icam-icon iconName="autocomplete-chevron-down" [iconHeight]="'7px'" />
        </div>
      }

      @if (value) {
        <button type="button" class="btn-clear" (click)="clearSelection()" [disabled]="disabled || isReloading">
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  }
}

